import { Permission } from "@shared/clickar-constants";

export class User {
	username: string;
	name: string;
	email: string;
	roles: string[];
}

export class PasswordRecovery {
	mode?: string;
	username?: string;
	email?: string;
}

export interface UsernamePasswordDTO {
	password?: string;
	username?: string;
}

export interface VerifyPasswordRecoveryDTO {
	confPassword?: string;
	hash?: string;
	password?: string;
	username?: string;
}

export interface IbanDTO {
	iban?: string;
	flgOnlinePayment?: boolean;
}

export class UserDTO {
	idUser: number;
	idDealer: number;
	name: string;
	surname: string;
	email: string;
	username: string;
	flgEnabled: boolean;
	flgMultiAuctioneer: boolean;
	birthDate: Date;
	idMarket: string;
	permission: (typeof Permission)[keyof typeof Permission];
	roles: string[];
	adminEnabledMarket: string[];
	consent1: boolean;
	consent2: boolean;
	consent3: boolean;
	preferredLanguage: string;
	fiscalCode: string;
	flgIam: boolean;
	flgExhibitor: boolean;
	flgAuctioneer: boolean;
	flgFirst: boolean;
}

export class PermissionDTO {
	idUser?: number;
	permission?: string;
}

export class NewUserEmailDTO {
	dealerId?: number;
	email?: string;
}

export class ChangePasswordDTO {
	confPassword?: string;
	password?: string;
}

export class UserSignUpDTO {
	birthDate?: Date;
	consent1?: boolean;
	consent2?: boolean;
	consent3?: boolean;
	dealerName?: string;
	email?: string;
	fiscalCode?: string;
	idDealer?: number;
	name?: string;
	surname?: string;
}

export interface UserBuyerTemplateDTO {
	acceptedRegulation?: string;
	businessName?: string;
	dateAccepted?: Date;
	dateCreate?: Date;
	lastLogin?: Date;
	email?: string;
	emailDealer?: string;
	flgEnabled?: boolean;
	idDealer?: number;
	idMarket?: string;
	name?: string;
	regulationVersion?: number;
	sincom?: string;
	surname?: string;
	templateName?: string;
	username?: string;
	vatCode?: string;
	permissions?: string[];
}

export interface UserBuyerSearchDTO {
	market?: string;
	blockedUser?: boolean;
	fcaUser?: boolean;
	province?: string;
	idTemplate?: number;
	vatCode?: string;
	accepted?: string;
}

export interface UsersBuyerSearchParamsDTO {
	accepted?: string;
	blockedUser?: boolean;
	fcaUser?: boolean;
	idTemplate?: number;
	market?: string;
	province?: string;
	vatCode?: string;
}

export interface FcmTokenDTO {
	fcmToken?: string;
}